import React, { useState } from 'react';
import DynamicComponentRenderer from '../../utility/DynamicComponentRenderer';

const DEFAULT_SNIPPET = `import React from 'react';

export default function Sandbox() {
  return (
    <div style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif' }}>
      <h1>Sandbox</h1>
      <p>Paste any component code here and click "Render" to see it.</p>
      <p>Use this to verify LLM output before pasting into a real admin form.</p>
    </div>
  );
}
`;

const ALLOWED = ['react', 'react-dom', 'chart.js', 'framer-motion', 'aicrowd-ui'];

export default function PasteSandbox() {
  const [draft, setDraft] = useState(DEFAULT_SNIPPET);
  const [rendered, setRendered] = useState(DEFAULT_SNIPPET);

  return (
    <div style={{ display: 'flex', gap: '1rem', padding: '1.5rem', height: '100vh', boxSizing: 'border-box' }}>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <h2 style={{ marginTop: 0 }}>Paste your code</h2>
        <textarea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          style={{
            flex: 1, fontFamily: 'Menlo, Monaco, monospace', fontSize: 12,
            padding: '0.75rem', border: '1px solid #cbd5e0', borderRadius: 4,
            background: '#1a202c', color: '#f7fafc', lineHeight: 1.5,
          }}
          spellCheck={false}
        />
        <button
          onClick={() => setRendered(draft)}
          style={{
            marginTop: '0.75rem', padding: '0.75rem', borderRadius: 4,
            background: '#4299e1', color: 'white', border: 'none', cursor: 'pointer',
            fontWeight: 600, fontSize: 14,
          }}
        >
          Render →
        </button>
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <h2 style={{ marginTop: 0 }}>Preview</h2>
        <div style={{
          flex: 1, padding: '1.5rem', border: '1px solid #e2e8f0',
          borderRadius: 8, background: 'white', overflow: 'auto',
        }}>
          <DynamicComponentRenderer
            componentCode={rendered}
            props={{}}
            allowedModules={ALLOWED}
          />
        </div>
      </div>
    </div>
  );
}
